import React from "react";
import {
  AdText,
  CompanyInfo,
  CompanyName,
  HeaderContainer,
  Logo
} from "./LogoCompanyHeader.styled";

const LogoCompanyHeader = ({ logoSrc, companyName, isDark }) => {
  return (
    <HeaderContainer isDark={isDark}>
      <Logo src={logoSrc} alt={`${companyName} logo`} />
      <CompanyInfo>
        <CompanyName>{companyName}</CompanyName>
        <AdText>Advertising</AdText>
      </CompanyInfo>
    </HeaderContainer>
  );
};

export default LogoCompanyHeader;
